export { default } from './DesktopPageNavigation';
